export function breakpointValue<T>(valueOrValues: any | any[], breakpoint: number) {
  return Array.isArray(valueOrValues)
    ? valueOrValues[Math.min(valueOrValues.length - 1, breakpoint || 0)]
    : valueOrValues;
}
